"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setLocale", {
  enumerable: true,
  get: function get() {
    return _intl.setLocale;
  }
});

require("../focus-ring-polyfill");

require("./style/index.css");

var _configureTypekit = _interopRequireDefault(require("../utils/configureTypekit"));

var _intl = require("../utils/intl");

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../spectrum-css/page/index.css");

  require("../spectrum-css/page/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../spectrum-css/page/index-lg.css");
} else {
  require("../spectrum-css/page/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../spectrum-css/page/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../spectrum-css/page/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../spectrum-css/page/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../spectrum-css/page/multiStops/darkest.css");

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../spectrum-css-overrides/typography/index.css");

  require("../spectrum-css-overrides/typography/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../spectrum-css-overrides/typography/index-lg.css");
} else {
  require("../spectrum-css-overrides/typography/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../spectrum-css-overrides/typography/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../spectrum-css-overrides/typography/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../spectrum-css-overrides/typography/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../spectrum-css-overrides/typography/multiStops/darkest.css");

if (process.browser) {
  (0, _configureTypekit["default"])('ruf7eed');

  if (!/coral--/.test(document.body && document.body.className)) {
    document.body.classList.add('coral--light');
    document.body.classList.add('spectrum');
    document.body.classList.add('spectrum--light');
  }
}

console.warn('react-spectrum/page is deprecated and will be removed in the next major version. ' + 'Please wrap your app in a <Provider> component instead. ' + 'See https://git.corp.adobe.com/React/react-spectrum-v2/releases/tag/v2.6.0');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react/react-spectrum/page/index.js
// module id = 430
// module chunks = 0